<template>
  <v-container>Welcome back!
    <Athlete :athlete="athlete"/>
  </v-container>
</template>

<script>
import Athlete from '@/ux/components/Athlete.vue';


export default {
  components: {
    Athlete,
  },
  data: () => ({
    athlete: {},
  }),
  mounted() {
    this.athlete = this.$store.state.athlete;
  },
  methods: {
  },
};
</script>

<style>
</style>
